const EnumtestActions = Object.freeze({
    CHANGE_SELECT: "CHANGE_SELECT",
});

module.exports.EnumtestActions = EnumtestActions;

class TestDataActions {
    constructor() {
        this.moduleName = "[ testDataActions.js ]";
    }

    get Actions() {
        return EnumtestActions;
    }

    changeSelect(newSelect) {
        console.log(this.moduleName + " ChangeSelect")
        return function (dispatch) {
            dispatch({ type: EnumtestActions.CHANGE_SELECT, newSelectValue: newSelect });
        }
    }
}
export default TestDataActions = new TestDataActions;